/* eslint-disable react/jsx-max-depth */
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import * as SC from "./styles";
import type { ITrafficWidgetLayoutProps } from "./types";

export const TrafficWidgetLayout = ({
    titleKey,
    tooltipKey,
    state,
    bodyByState,
    rightAsideByState,
    emptyStateOverlay,
    dataAutomation,
    isLoading,
    onClick,
    titleSupplement,
}: ITrafficWidgetLayoutProps) => {
    const body = bodyByState[state] ?? bodyByState.default;
    const rightAside = rightAsideByState && (rightAsideByState[state] ?? rightAsideByState.default);
    const isEmpty = state === "empty";
    const isLoadingState = state === "loading" || isLoading;
    const isRightAside = rightAside != null;
    const containerOnClick = isLoadingState ? undefined : onClick;

    const content = (
        <>
            <SC.MainColumn $isRightAside={isRightAside}>
                <SC.Header $isActive={!!containerOnClick}>
                    <SC.HeaderFlex
                        alignItems="center"
                        gap="4px"
                    >
                        <SC.TitleText>{translate(titleKey)}</SC.TitleText>

                        {titleSupplement}

                        <Tooltip content={translate(tooltipKey)}>
                            <SC.InfoIcon
                                color={colorsPalettes.carbon[200]}
                                size={16}
                            />
                        </Tooltip>
                    </SC.HeaderFlex>
                </SC.Header>

                <SC.Body>{body}</SC.Body>
            </SC.MainColumn>

            {isRightAside ? <SC.RightAside>{rightAside}</SC.RightAside> : null}

            {isEmpty && emptyStateOverlay != null ? (
                <SC.EmptyStateOverlayWrapper role="presentation">{emptyStateOverlay}</SC.EmptyStateOverlayWrapper>
            ) : null}
        </>
    );

    return (
        <SC.Container
            onClick={containerOnClick}
            data-state={state}
            data-automation={dataAutomation}
        >
            {content}
        </SC.Container>
    );
};
